import utils from './utils';
import '../../vendor/jquery.autocomplete';

// autocomplete functionality
function searchAutocomplete($inputWrapper) {
    let $input = $inputWrapper.find('.input-field');
    import('../../autoCompleteListCompressed.json').then(data => {
        let searchdata = data.default.map(function(part){
            return part.mpn;
        });
        let searchmap = {};
        data.default.forEach(function(part) {
            searchmap[part.mpn] = part['class'];
        });
        if ($input.length) {
            //add auto complete feature to search box
            $input.autocomplete(searchdata, {
                selectFirst: false,
                holder: '#' + $inputWrapper.attr('id') + ' .autocomplete-holder',
                noRecord: '',
                max: 4,
                highlight: function(value, term) {
                    return utils.autocompleteHighlight(value, term, searchmap);
                }
            });
            //add auto submit upon selection (either by click or enter)
            $input.result(function(event) {
                $(event.target.form).submit();
            });
        }
    });
}

export default { searchAutocomplete };